import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const subscribeSchema = z.object({
  email: z
    .string()
    .trim()
    .email({ message: "Enter a valid email address" })
    .max(255),
  source: z.string().trim().max(50).optional(),
});

// Public, unauthenticated: stores a newsletter signup. Returns nothing
// beyond success — never exposes whether an address already exists.
export const subscribeNewsletter = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => subscribeSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const email = data.email.toLowerCase();
    const { error } = await supabaseAdmin
      .from("newsletter_subscribers")
      .upsert(
        { email, source: data.source ?? "website" },
        { onConflict: "email", ignoreDuplicates: true },
      );
    if (error) {
      console.error("subscribeNewsletter failed:", error.message);
      throw new Error("Could not save your signup. Please try again.");
    }
    return { ok: true };
  });
